import text from '../cnConst/text'
import showText from '../cnConst/showText'
import showKey from '../cnConst/showKey'
import showAuthor from '../cnConst/showAuthor'
import openArgument from '../cnConst/openArgument'
import inputType from '../cnConst/inputType'
import inputKey from '../cnConst/inputKey'
import defaultValue from '../cnConst/defaultValue'
import randomShowKey from '../cnConst/randomShowKey'
import httpApi from './httpApi'
import openSites from './openSites'
import executeKey from './executeKey'
import defaultStyle from './defaultStyle'
import asyncInputKey from './asyncInputKey'
import outFunctions from './outFunctions'
import styleKey from './styleKey'
import storageKey from './storageKey'
import count from './count'
const cnConst = {
  text
  ,showText
  ,showKey
  ,showAuthor
  ,openArgument
  ,inputType
  ,inputKey
  ,defaultValue
  ,randomShowKey
  ,httpApi
  ,openSites
  ,executeKey
  ,defaultStyle
  ,asyncInputKey
  ,outFunctions
  ,styleKey
  ,storageKey
  ,count
}
export default cnConst



// WEBPACK FOOTER //
// ./src/cnConst/cnConst.js